module.exports = {
    hygl: {
        ytRecord: {
            title: '选择议题'
        }
    }
}
